import { render, staticRenderFns } from "./inbupload.vue?vue&type=template&id=42ec97ff&scoped=true"
import script from "./inbupload.vue?vue&type=script&lang=js"
export * from "./inbupload.vue?vue&type=script&lang=js"
import style0 from "./inbupload.vue?vue&type=style&index=0&id=42ec97ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ec97ff",
  null
  
)

export default component.exports